module.exports = __webpack_public_path__ + "img/3.8b36c528.webp";